import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-success-trancaction',
  templateUrl: './success-trancaction.component.html',
  styles: ``
})
export class SuccessTrancactionComponent {
  constructor(dialogRef: MatDialogRef<SuccessTrancactionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,) {

  }
}
